<template>
  <div class="validation-rules">
    <GText
      variant="subtitle-03"
      class="title"
    >
      {{ $t('reset.validationRulesTitle') }}
    </GText>
    <GBox :mt="8">
      <ul class="rules-list">
        <li
          v-for="(validationRule, idx) in validationRules"
          :key="idx"
        >
          <GBox
            flex
            class="rule-icon-wrapper"
          >
            <GBox>
              <span v-if="initial">
                &#8226;
              </span>
              <GIcon
                size="14"
                color="red-500"
                v-else-if="has(validationRule.key)"
                name="x-circle"
              />
              <GIcon
                v-else
                size="14"
                name="check-circle"
                color="green-500"
              />
            </GBox>
          </GBox>
          <GBox>
            <GText :color="validationTextColor(validationRule.key)">
              {{ $t(`reset.validationRules.${validationRule.key}`) }}
            </GText>
          </GBox>
        </li>
      </ul>
    </GBox>
  </div>
</template>

<script>
import GText from '@trendyol-js/grace/core/GText';
import GBox from '@trendyol-js/grace/core/GBox';
import GIcon from '@trendyol-js/grace/core/GIcon';

export default {
  name: 'ValidationRules',

  components: {
    GText,
    GBox,
    GIcon,
  },

  props: {
    initial: {
      type: Boolean,
      default: true,
    },
    validationResults: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    validationRules () {
      return [
        {
          key: 'min',
        },
        {
          key: 'noNumber',
        },
        {
          key: 'noUpperAndLowerCase',
        },
        {
          key: 'noSpecialCharacter',
        },
      ];
    },
  },

  methods: {
    validationTextColor (key) {
      if (!this.initial && this.has(key)) {
        return 'red-500';
      }
      if (!this.initial && !this.has(key)) {
        return 'green-500';
      }
    },

    has (ruleName) {
      return this.validationResults.find((err) => err.rule === ruleName);
    },
  },
};
</script>

<style lang="scss" scoped>
  .validation-rules {
    .rule-icon-wrapper {
      min-width: 18px
    }

    .rules-list {
      padding: 0 !important;
      margin: 0 !important;
      li {
        display: flex;
        list-style-type: none;
        font-size: 12px;
        color: #273142;
        &:not(:last-child) {
          margin-bottom: 13px;
        }

        img, span {
          margin-right: 8px;
        }
      }
    }
  }
</style>
